import useNavPoint from "@src/@hooks/useNavPoint";
import { useAppSelectorV1 } from "@src/@redux/hooks";
import { buildPath, useNavigation } from "@thenounproject/lingo-core";
import { useEffect, useMemo } from "react";

const useActiveSection = () => {
  const { kit, kitVersion, section, portal, space } = useNavPoint() ?? {};
  const navigate = useNavigation();

  const firstSection = useAppSelectorV1(state => {
    const sectionIds = kitVersion?.sections ?? [];
    for (const id of sectionIds) {
      const sec = state.entities.sections.objects[id];
      if (sec && !sec.isSeparator) return sec;
    }
    return null;
  });

  const displaySection = useMemo(() => {
    let s = section;
    if (!section && firstSection) {
      s = firstSection;
    }
    return s;
  }, [firstSection, section]);

  useEffect(() => {
    if (displaySection?.isSeparator) {
      navigate.replace(buildPath(`/k/${kit.urlId}`, { space, portal }));
    }
  }, [displaySection?.isSeparator, kit?.urlId, navigate, portal, space]);

  return displaySection;
};

export default useActiveSection;
